export interface PrintableCertificate {
  certificate_number: string;
  student_name: string;
  course_name: string;
  issue_date: string;
  notes?: string | null;
  blank_template?: boolean;
}

const esc = (s: string) =>
  s.replace(/[&<>"']/g, (c) => ({ "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;", "'": "&#39;" }[c] as string));

const fmtDate = (d: string) => {
  const [y, m, day] = d.split("-");
  return y && m && day ? `${day}.${m}.${y}` : d;
};

export const printPracticeCertificates = (certs: PrintableCertificate[], autoPrint = true) => {
  const w = window.open("", "_blank");
  if (!w) return false;
  const origin = window.location.origin;
  const pages = certs
    .map((c) => {
      const verify = `https://globalitacademy.am/certificate-verification?number=${encodeURIComponent(c.certificate_number)}`;
      const qr = `https://api.qrserver.com/v1/create-qr-code/?size=180x180&data=${encodeURIComponent(verify)}`;
      return `<section class="page${c.blank_template ? " blank-template" : ""}"><div class="frame"><div class="inner">
<img class="logo" src="${origin}/global-it-logo.png" alt="Global IT Academy"/>
<div class="kicker">GLOBAL IT ACADEMY</div>
<h1>\u054A\u0550\u0531\u053F\u054F\u053B\u053F\u0531\u0545\u053B \u054E\u053F\u0531\u0545\u0531\u053F\u0531\u0546</h1>
<div class="sub">CERTIFICATE OF INTERNSHIP</div>
<p class="lead">\u054D\u0578\u0582\u0575\u0576\u0578\u057E \u0570\u0561\u057E\u0561\u057D\u057F\u057E\u0578\u0582\u0574 \u0567, \u0578\u0580</p>
<div class="name">${esc(c.student_name)}</div>
${c.blank_template && !c.student_name ? `<div class="lbl name-label">\u0531\u0576\u0578\u0582\u0576 \u0531\u0566\u0563\u0561\u0576\u0578\u0582\u0576</div>` : ""}
${c.blank_template ? "" : `<p class="lead">\u0570\u0561\u057B\u0578\u0572\u0578\u0582\u0569\u0575\u0561\u0574\u0562 \u0561\u0576\u0581\u0565\u056C \u0567 \u0563\u0578\u0580\u056E\u0576\u0561\u056F\u0561\u0576 \u057A\u0580\u0561\u056F\u057F\u056B\u056F\u0561\u0576</p>`}
${c.course_name ? `<div class="course">\u00AB${esc(c.course_name)}\u00BB</div>` : ""}
${c.notes ? `<p class="notes">${esc(c.notes)}</p>` : ""}
<div class="foot">
<div class="col"><div class="line"></div><div class="lbl">\u054F\u0576\u0585\u0580\u0565\u0576</div></div>
<div class="col center"><div class="seal-space"></div><div class="lbl certificate-number">\u2116 ${esc(c.certificate_number)}</div></div>
<div class="col"><div class="val">${esc(fmtDate(c.issue_date))}</div><div class="line"></div><div class="lbl">\u054F\u0580\u0574\u0561\u0576 \u0561\u0574\u057D\u0561\u0569\u056B\u057E</div></div>
</div>
<div class="site">www.globalitacademy.am</div>
<img class="qr" src="${qr}" alt="QR"/>
</div></div></section>`;
    })
    .join("");

  w.document.write(`<!doctype html><html lang="hy"><head><meta charset="utf-8"><title>Certificates</title>
<link href="https://fonts.googleapis.com/css2?family=Noto+Serif+Armenian:wght@400;700&family=Noto+Sans+Armenian:wght@400;600&display=swap" rel="stylesheet">
<style>
@page{size:A4 landscape;margin:0}
*{box-sizing:border-box;-webkit-print-color-adjust:exact;print-color-adjust:exact}
body{margin:0;background:#e5e7eb;font-family:'Noto Sans Armenian',sans-serif;color:#0f172a}
.page{width:297mm;height:210mm;margin:10mm auto;background:#fff;padding:10mm;page-break-after:always;position:relative;overflow:hidden}
.page::before{content:"";position:absolute;inset:0;background:radial-gradient(circle at 0 0,#10b98122,transparent 40%),radial-gradient(circle at 100% 100%,#0ea5e922,transparent 40%)}
.frame{position:relative;height:100%;border:3px solid #059669;padding:4mm}
.inner{position:relative;height:100%;border:1px solid #10b98188;display:flex;flex-direction:column;align-items:center;text-align:center;padding:8mm 16mm 54mm}
.inner> :not(.foot):not(.site):not(.qr){flex-shrink:0}
.logo{height:14mm;object-fit:contain}
.kicker{letter-spacing:6px;font-size:10pt;color:#059669;margin-top:2mm;font-weight:600}
h1{font-family:'Noto Serif Armenian',serif;font-size:30pt;margin:5mm 0 1mm;letter-spacing:2px}
.sub{font-size:10pt;letter-spacing:4px;color:#64748b}
.lead{margin:6mm 0 2mm;font-size:13pt;color:#334155}
.name{font-family:'Noto Serif Armenian',serif;font-size:28pt;font-weight:700;color:#047857;border-bottom:1px solid #cbd5e1;padding:0 12mm 2mm;min-width:150mm}
.course{font-size:17pt;font-weight:600;margin-top:1mm}
.notes{font-size:11pt;color:#475569;max-width:200mm;margin:3mm 0 0}
.foot{position:absolute;bottom:14mm;left:16mm;right:16mm;display:flex;justify-content:space-between;align-items:flex-end}
.col{width:60mm;text-align:center}.line{border-top:1px solid #0f172a;margin:2mm 0 1mm}
.lbl{font-size:9pt;color:#64748b}.val{font-size:12pt}.qr{position:absolute;right:6mm;bottom:6mm;width:15mm;height:15mm}
.seal-space{height:28mm;width:28mm;margin:0 auto}.certificate-number{margin-top:2mm;overflow-wrap:anywhere}
.blank-template .name{min-height:18mm;margin-top:3mm}.name-label{margin-top:2mm}.blank-template .course{margin-top:8mm;max-width:100%;overflow-wrap:anywhere}
.site{position:absolute;bottom:4mm;left:24mm;right:24mm;font-size:9pt;color:#059669;text-align:center}
@media print{body{background:#fff}.page{margin:0}}
</style></head><body>${pages}
${autoPrint ? "<script>window.onload=()=>setTimeout(()=>window.print(),700)</script>" : ""}</body></html>`);
  w.document.close();
  return true;
};
